export const USER_EXCHANGE_CODES = {
    AUCTION: { value: "AUCTION", text: "옥션" },
    GMARKET: { value: "GMARKET", text: "지마켓" },
    SSG_COM: { value: "SSG_COM", text: "SSG" },
    LOTTEON: { value: "LOTTEON", text: "롯데ON" },
    // TESTCODE: { value: "TESTCODE", text: "테스트" },
};
